/* eslint-disable spire/export-styles */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import Select, { SelectPresentationProps, SelectProps } from "@insite/mobius/Select";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getTranslatedUom } from "@WhiteCap/Utils/UomTranslation";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    wrapper?: InjectableCss;
    labelOverride?: TypographyProps;
    valueOverride?: TypographyProps;
    showLabel: boolean;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasProductContext;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    isAuthenticated: state.context.session.isAuthenticated,
    language: state.context.session.language?.languageCode,
});

export const productUnitOfMeasureSelectStyles: SelectPresentationProps = {};

const ProductUnitOfMeasure: React.FC<Props> = ({
    productContext: { product },
    wrapper,
    labelOverride,
    valueOverride,
    showLabel,
    isAuthenticated,
    language,
}) => {
    if (!product.unitOfMeasures?.length) {
        return null;
    }

    const uom = product.unitOfMeasures.filter(uom => uom.isDefault)[0];

    const displayUom = getTranslatedUom(
        uom.unitOfMeasureDisplay,
        language ?? "",
    );

    if (isAuthenticated) return null;

    return (
        <StyledWrapper {...wrapper}>
            {showLabel && (
                <StyledWrapper as="span" {...labelOverride}>
                    {translate("UOM:")}
                </StyledWrapper>
            )}
            <Typography data-test-selector="productPrice_unitOfMeasureLabel" {...valueOverride}>
                {/* ({uom.unitOfMeasureDisplay}) */}
                  ({displayUom})
            </Typography>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(withProductContext(ProductUnitOfMeasure));
